/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Pure_Wasp_WalkInputs */

const en_gray_pure_wasp_walk = /** @type {(inputs: Gray_Pure_Wasp_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user and all connected settings will be deleted from the organization`)
};

const de_gray_pure_wasp_walk = /** @type {(inputs: Gray_Pure_Wasp_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer und alle verbundenen Einstellungen werden aus der Organisation entfernt.`)
};

/**
* | output |
* | --- |
* | "The user and all connected settings will be deleted from the organization" |
*
* @param {Gray_Pure_Wasp_WalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_pure_wasp_walk = /** @type {((inputs?: Gray_Pure_Wasp_WalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Pure_Wasp_WalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_pure_wasp_walk(inputs)
	return de_gray_pure_wasp_walk(inputs)
});